import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                photo: null,
                photo_inside: false,
                photo_label: '',
                published_at: '',
                title: '',
                external_link: '',
                slug: '',
                locale: window.laravel.locale,
                published: true,
                short_description: '',
                description: '',
                categories: [],
                imagesInDescription: [],
            },
        }
    },
    mutations: {
        setForm(state, value) {
            window.Vue.set(state, 'form', value);
        },
        setCategories(state, value) {
            window.Vue.set(state, 'categories', value);
        },
        removeCategory(state, value) {
            let categories = state.form.categories.filter(
                (category) => {
                    return value.id !== category.id
                }
            );

            window.Vue.set(state.form, 'categories', categories);
        },
    },
    actions: {
        createNews({state}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/admin/news', payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        editNews({state}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.update('/admin/news/'+payload.id, payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getArticle({state, commit}, articleId) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin/news', { id: articleId })
                    .then((response) => {
                        resolve(response);
                        commit('setForm', response.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        clearForm({state}) {
            let properties = {
                photo: null,
                photo_inside: false,
                published: true,
                categories: []
            };

            let ignoreProperties = [
                'locale'
            ];

            Object.keys(state.form)
                .filter(property => !ignoreProperties.includes(property))
                .forEach((property) => {
                    if (properties.hasOwnProperty(property)) {
                        state.form[property] = properties[property];
                    } else {
                        state.form[property] = '';
                    }
                });
        }
    }
};
